module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Regular.bc2b06c4e8d1a5249f43b2272c797778.woff";